export { default as FolderOpenOutlineIcon } from './FolderOpenOutlineIcon';
